// This file is nearly the same as useSeekTimeScroll. We decided to make this file independent from
// that file so that the transcript editor stuff can remain independent of the transcript.
import * as React from 'react';

import { SlateLeafSelector, slateSnippetSelector } from 'src/util/slate';

/** scrolls the transcript for find-and-replace & redactions */
export function useTranscriptScroll(
  scrollContainerRef: React.RefObject<HTMLElement>,
  seekTime?: number,
  searchIndex?: number,
  onScrollInterruption?: () => void | undefined
) {
  React.useEffect(() => {
    if (searchIndex != null) {
      onScrollInterruption?.();
      scrollContainerRef?.current
        ?.querySelector(`${SlateLeafSelector}[data-focused-search="true"]`)
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [scrollContainerRef, searchIndex, onScrollInterruption]);

  // for time-based scroll
  const scroll = React.useCallback(
    (time: number, onScrollCompletion?: () => void) => {
      onScrollInterruption?.();

      scrollContainerRef?.current
        ?.querySelector(slateSnippetSelector(time))
        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });

      onScrollCompletion?.();
    },
    [onScrollInterruption, scrollContainerRef]
  );
  return scroll;
}
